<div class="data-source-container">
  <h2>Client Data Sources</h2>
  <div class="actions">
    <button (click)="onAdd()" [disabled]="isEditingAnyRow">Add</button>
  </div>

  <div *ngIf="loading" class="status">Loading...</div>
  <div *ngIf="error" class="error">{{ error }}</div>

  <table *ngIf="!loading && dataSources.length > 0">
    <thead>
      <tr>
        <th>Name</th>
        <th>Connection Type</th>
        <th>Encrypted?</th>
        <th>Source Type</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let ds of dataSources">
        <!-- Display row -->
        <tr *ngIf="!ds.editing">
          <td>{{ ds.name }}</td>
          <td>{{ ds.connectionType }}</td>
          <td>{{ ds.legacyEncryption ? 'Yes' : 'No' }}</td>
          <td>
            {{
                ds.connectionType === 'Data'
                  ? ds.data['DataSourceType']
                  : ds.data['Type']
            }}
          </td>
          <td>
            <button class="edit" (click)="onEdit(ds)">Edit</button>
            <button class="delete" (click)="onDelete(ds.DataSourceId)">Delete</button>
          </td>
        </tr>

        <!-- Edit row -->
        <tr *ngIf="ds.editing">
          <td colspan="5">
            <div class="edit-section">
              <label>
                Name:
                <input [(ngModel)]="ds.name" />
              </label>

              <label>
                Table Prefix:
                <input [(ngModel)]="ds.tablePrefix" />
              </label>

              <label>
                Legacy Encryption:
                <input type="checkbox" [(ngModel)]="ds.legacyEncryption" />
              </label>

              <label>
                Connection Type:
                <select [(ngModel)]="ds.connectionType">
                  <option value="File">File</option>
                  <option value="Data">Data</option>
                </select>
              </label>

              <!-- File connections -->
              <div *ngIf="ds.connectionType === 'File'">
                <label>
                  File Type:
                  <select [(ngModel)]="ds.data['Type']">
                    <option value="Ftp">Ftp</option>
                    <option value="Sftp">Sftp</option>
                    <option value="Azure">Azure</option>
                    <option value="Local">Local</option>
                    <option value="DataLake">DataLake</option>
                  </select>
                </label>

                <!-- FTP -->
                <div *ngIf="ds.data['Type'] === 'Ftp'">
                  <h4>FTP Settings</h4>
                  <label>Server: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>Port: <input type="number" [(ngModel)]="ds.data['Port']" placeholder="21" /></label>
                  <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                  <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  <label>Root Path: <input [(ngModel)]="ds.data['RootPath']" placeholder="/" /></label>
                  <label>Timeout (ms): <input type="number" [(ngModel)]="ds.data['Timeout']" placeholder="30000" /></label>
                  <label>
                    Enable Certificate Validation:
                    <input type="checkbox" [(ngModel)]="ds.data['EnableCertificateValidation']" />
                  </label>
                  <label>
                    Enable Passive Mode:
                    <input type="checkbox" [(ngModel)]="ds.data['EnablePassiveMode']" />
                  </label>
                  <label>
                    Enable Secure FTP (FTPS):
                    <input type="checkbox" [(ngModel)]="ds.data['EnableSecureFtp']" />
                  </label>
                </div>


                <!-- SFTP -->
                <div *ngIf="ds.data['Type'] === 'Sftp'">
                  <h4>SFTP Settings</h4>
                  <label>Server: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>Port: <input type="number" [(ngModel)]="ds.data['Port']" placeholder="22" /></label>
                  <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                  <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  <label>Root Path: <input [(ngModel)]="ds.data['RootPath']" placeholder="/" /></label>
                  <label>Timeout (ms): <input type="number" [(ngModel)]="ds.data['Timeout']" placeholder="30000" /></label>
                </div>


                <!-- Azure -->
                <div *ngIf="ds.data['Type'] === 'Azure'">
                  <h4>Azure Settings</h4>
                  <label>Connection String: <input [(ngModel)]="ds.data['ConnectionString']" /></label>
                  <label>Container Name: <input [(ngModel)]="ds.data['ContainerName']" /></label>
                  <label>SAS Token: <input type="password" [(ngModel)]="ds.data['SasToken']" /></label>
                  <label>
                    TLS Version:
                    <select [(ngModel)]="ds.data['TlsVersion']">
                      <option value="v1_0">1.0</option>
                      <option value="v1_1">1.1</option>
                      <option value="v1_2">1.2</option>
                    </select>
                  </label>
                </div>

                <!-- Local -->
                <div *ngIf="ds.data['Type'] === 'Local'">
                  <h4>Local Settings</h4>
                  <label>Root Path: <input [(ngModel)]="ds.data['RootPath']" /></label>
                </div>

                <!-- DataLake -->
                <div *ngIf="ds.data['Type'] === 'DataLake'">
                  <h4>DataLake Settings</h4>`
                  <label>Account Name: <input [(ngModel)]="ds.data['AccountName']" /></label>
                  <label>File System Name: <input [(ngModel)]="ds.data['FileSystemName']" /></label>
                  <label>Account Key: <input type="password" [(ngModel)]="ds.data['AccountKey']" /></label>
                  <label>
                    Auto Create Directories:
                    <input type="checkbox" [(ngModel)]="ds.data['AutoCreateDirectories']" />
                  </label>
                  <label>
                    TLS Version:
                    <select [(ngModel)]="ds.data['TlsVersion']">
                      <option value="v1_0">1.0</option>
                      <option value="v1_1">1.1</option>
                      <option value="v1_2">1.2</option>
                    </select>
                  </label>
                </div>
              </div>

              <!-- Data connections -->
              <div *ngIf="ds.connectionType === 'Data'">
                <label>
                  DataSource Type:
                  <select [(ngModel)]="ds.data['DataSourceType']">
                    <option value="SqlServer">SQL Server</option>
                    <option value="SqLite">SQLite</option>
                    <option value="Oracle">Oracle</option>
                    <option value="PostgreSql">PostgreSQL</option>
                    <option value="Snowflake">Snowflake</option>
                    <option value="SnowflakeBatched">Snowflake (Batched)</option>
                    <option value="PelotonCloud">Peloton Cloud</option>
                    <option value="OpenWellsCloud">OpenWells Cloud</option>
                  </select>
                </label>

                <!-- SQL Server -->
                <div *ngIf="ds.data['DataSourceType'] === 'SqlServer'">
                  <h4>SQL Server Settings</h4>
                  <label>Server: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>Database: <input [(ngModel)]="ds.data['Database']" /></label>
                  <label *ngIf="'Trusted' in ds.data">
                    Trusted Connection:
                    <input type="checkbox" [(ngModel)]="ds.data['Trusted']" />
                  </label>
                  <!-- Only show if Trusted is false -->
                  <div *ngIf="!ds.data['Trusted']">
                    <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                    <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  </div>
                  <label>
                    Enable Pooling:
                    <input type="checkbox" [(ngModel)]="ds.data['EnablePooling']" />
                  </label>
                </div>


                <!-- SQLite -->
                <div *ngIf="ds.data['DataSourceType'] === 'SqLite'">
                  <h4>SQLite Settings</h4>
                  <label>DataSource (file path): <input [(ngModel)]="ds.data['DataSource']" /></label>
                </div>

                <!-- Oracle -->
                <div *ngIf="ds.data['DataSourceType'] === 'Oracle'">
                  <h4>Oracle Settings</h4>
                  <label>Server: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                  <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  <label>Database (optional): <input [(ngModel)]="ds.data['Database']" /></label>

                </div>

                <!-- PostgreSQL -->
                <div *ngIf="ds.data['DataSourceType'] === 'PostgreSql'">
                  <h4>PostgreSQL Settings</h4>
                  <label>Server: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                  <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  <label>Database (optional): <input [(ngModel)]="ds.data['Database']" /></label>
                </div>

                <!-- Snowflake / SnowflakeBatched -->
                <div *ngIf="ds.data['DataSourceType'] === 'Snowflake' || ds.data['DataSourceType'] === 'SnowflakeBatched'">
                  <h4>Snowflake Settings</h4>
                  <label>Host: <input [(ngModel)]="ds.data['Server']" /></label>
                  <label>User: <input [(ngModel)]="ds.data['User']" /></label>
                  <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                  <label>Private Key: <input type="password" [(ngModel)]="ds.data['PrivateKey']" /></label>
                  <label>Private Key File: <input [(ngModel)]="ds.data['PrivateKeyFile']" /></label>
                  <label>Private Key Passphrase: <input type="password" [(ngModel)]="ds.data['PrivateKeyPassphrase']" /></label>
                  <label>Account: <input [(ngModel)]="ds.data['Account']" /></label>
                  <label>Role: <input [(ngModel)]="ds.data['Role']" /></label>
                  <label>Database: <input [(ngModel)]="ds.data['Database']" /></label>
                  <label>Schema: <input [(ngModel)]="ds.data['Schema']" /></label>
                  <label>Warehouse: <input [(ngModel)]="ds.data['Warehouse']" /></label>
                  <label>Pooling: <input type="checkbox" [(ngModel)]="ds.data['Pooling']" /></label>
                  <label>Connection Timeout (ms): <input type="number" [(ngModel)]="ds.data['ConnectionTimeout']" /></label>
                  <label>Client Session Keep Alive: <input type="checkbox" [(ngModel)]="ds.data['ClientSessionKeepAlive']" /></label>
                </div>

                <!-- Peloton Cloud -->
                <div *ngIf="ds.data['DataSourceType'] === 'PelotonCloud'">
                  <h4>Peloton Cloud Settings</h4>
                  <label>Authority: <input [(ngModel)]="ds.data['Authority']" /></label>
                  <label>ClientId: <input [(ngModel)]="ds.data['ClientId']" /></label>
                  <label>RedirectUri: <input [(ngModel)]="ds.data['RedirectUri']" /></label>
                  <label>RefreshToken: <input [(ngModel)]="ds.data['RefreshToken']" /></label>
                  <label>ClientSecret: <input type="password" [(ngModel)]="ds.data['ClientSecret']" /></label>
                  <label>SubscriptionKey: <input [(ngModel)]="ds.data['SubscriptionKey']" /></label>
                  <label>Scope: <input [(ngModel)]="ds.data['Scope']" /></label>
                  <label>
                    ApiVersion:
                    <select [(ngModel)]="ds.data['ApiVersion']">
                      <option value="v1_1">1.1</option>
                      <option value="v1_2">1.2</option>
                    </select>
                  </label>
                  <label>OrganizationName: <input [(ngModel)]="ds.data['OrganizationName']" /></label>
                  <label>ApplicationName: <input [(ngModel)]="ds.data['ApplicationName']" /></label>
                  <label>ApiBaseUrl: <input [(ngModel)]="ds.data['ApiBaseUrl']" /></label>
                  <label>Calls Per Second: <input type="number" [(ngModel)]="ds.data['CallsPerSecond']" placeholder="5" /></label>
                  <label>Retry Count: <input type="number" [(ngModel)]="ds.data['RetryCount']" placeholder="5" /></label>
                  <label>
                    Report Endpoint Information:
                    <input type="checkbox" [(ngModel)]="ds.data['ReportEndpointInformation']" />
                  </label>
                  <label>Entity Table: <input [(ngModel)]="ds.data['EntityTable']" placeholder="wvwellheader" /></label>
                  <label>Entity Field: <input [(ngModel)]="ds.data['EntityField']" placeholder="idwell" /></label>
                  <label>
                    Use Audience:
                    <input type="checkbox" [(ngModel)]="ds.data['UseAudience']" />
                  </label>
                  <label>Page Size: <input type="number" [(ngModel)]="ds.data['PageSize']" /></label>
                </div>
              </div>

              <!-- Open Wells Cloud -->
              <div *ngIf="ds.data['DataSourceType'] === 'OpenWellsCloud'">
                <h4>OpenWells Cloud Settings</h4>
                <label>User Name: <input [(ngModel)]="ds.data['User']" /></label>
                <label>Password: <input type="password" [(ngModel)]="ds.data['Password']" /></label>
                <label>Client Id: <input [(ngModel)]="ds.data['ClientId']" /></label>
                <label>Token URL: <input [(ngModel)]="ds.data['TokenUrl']" /></label>
                <label>Base URL: <input [(ngModel)]="ds.data['BaseUrl']" /></label>
                <label>Project Id: <input [(ngModel)]="ds.data['ProjectId']" /></label>
              </div>

              <div class="actions">
                <button class="save" (click)="onSave(ds)">Save</button>
                <button class="cancel" (click)="onCancel(ds)">Cancel</button>
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
    </tbody>
  </table>

  <div *ngIf="!loading && dataSources.length === 0" class="status">No data sources found.</div>
</div>
